<script>
  import ProfileImg from '../../components/ProfileImage.svelte';
  import FilePreview from '../../components/FilePreview.svelte';
  import SubCategoryBadge from '../../components/AddClient/SubCategoryBadge.svelte';
  import FundsItems from './FundsItems.svelte';
  import moment from 'moment';
  import { navigate } from 'svelte-routing';
  import {
    cloneArray,
    configItem,
    showNumberFormat,
    createLinkIfValidUrl,
    fileDownload,
  } from 'components/Helper.js';
  let photoUrl =
    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8FuEJbKwDdaz1h387130xmYkAIQbZpahhbQ&usqp=CAU';

  let detail = {};
  let pastProject = [];
  let activeProject = [];
  let unitIds = [];
  export let isActivityLog = false;
  export let clientModal;
  let clientFundProfileId;

  let selectUnitsInfo = {
    ukCompliance: false,
    outsourcedCfo: false,
    fundAdmin: false,
    usCompliance: false,
  };

  const setSelectUnitsInfo = (unitId) => {
    selectUnitsInfo.ukCompliance = unitIds.uk_compliance == unitId;
    selectUnitsInfo.outsourcedCfo = unitIds.outsourced_cfo == unitId;
    selectUnitsInfo.fundAdmin = unitIds.fund_admin == unitId;
    selectUnitsInfo.usCompliance = unitIds.us_compliance == unitId;
  };

  export const show = (clientId, clientDetail, masterUnitIds, clientFundProfileIds) => {
    clientFundProfileId = clientFundProfileIds;
    detail = cloneArray(clientDetail);
    unitIds = masterUnitIds;
    setSelectUnitsInfo(detail.unitId);

    pastProject = [];
    activeProject = [];

    let now = moment();
    for (const i in detail.projectTypes) {
      let date = moment(detail.projectTypes[i].endDate);
      if (detail.projectTypes[i].endDateFormat == '' || now < date) {
        activeProject.push(detail.projectTypes[i]);
      } else {
        pastProject.push(detail.projectTypes[i]);
      }
    }
    if (clientFundProfileId != undefined) {
      setTimeout(() => {
        document.getElementById('pills-tabContent').scrollTop =
          document.getElementById('fundDivRef').offsetTop;
      }, 100);
    }
  };

  export let viewGroup = () => {};
</script>

{#if detail.clientTypes != undefined && detail.clientTypes.length > 0}
  <!-- Client Type -->
  <div class="p-3 content-section pb-0">
    <span class="font-size-14 mb-2 font-weight-500 d-block">Client Type</span>
    <div class="row mb-1">
      <div class="col-md-12">
        <div class="box-block rounded p-2 client-type-main">
          <div class="row">
            {#each detail.clientTypes as client, i}
              <div class="col-md-12 client-type-inner">
                <div class="flex-column d-flex">
                  <div class="me-1">
                    <label
                      for=""
                      class="font-weight-500">{client.name}</label
                    >
                  </div>
                  <div class="d-flex flex-row flex-wrap">
                    {#if client.subClientTypes != undefined}
                      {#each client.subClientTypes as subClient, i}
                        <div class="me-1">
                          <SubCategoryBadge
                            Style="mb-1 mt-1"
                            name={subClient.name}
                          />
                        </div>
                      {/each}
                    {/if}
                  </div>
                </div>
                <hr />
              </div>
            {/each}
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Client Type End -->
{/if}

{#if detail.registrationTypes != undefined && detail.registrationTypes.length > 0}
  <!-- Registration Type -->
  <div class="p-3 content-section pb-0">
    <span class="font-size-14 mb-2 font-weight-500 d-block">Registration Type</span>
    <div class="row mb-1">
      <div class="col-md-12">
        <div class="flex-column d-flex">
          <div class="row">
            <div class="col-md-12">
              <div class="box-block rounded p-2">
                {#each detail.registrationTypes as registration, i}
                  <label
                    for=""
                    class="mb-1 font-weight-500">{registration.name}</label
                  >

                  {#if registration.subRegistrationTypes}
                    <div class="d-flex flex-row flex-wrap">
                      {#each registration.subRegistrationTypes as subRegistration, i}
                        <SubCategoryBadge
                          Style="mb-1 me-1"
                          name={subRegistration.name}
                        />
                      {/each}
                    </div>
                  {/if}
                  <div class="row mt-1">
                    {#if unitIds.outsourced_cfo != detail.unitId && registration.registrationNo != null}
                      <div class="col-md-6">
                        <span class="title color-blue d-block mb-1 font-weight-500"
                          >Registration No.</span
                        >
                        <span class="font-size-12 font-weight-400 d-block"
                          >{registration.registrationNo != null
                            ? registration.registrationNo
                            : ''}</span
                        >
                      </div>
                    {/if}
                    {#if unitIds.outsourced_cfo != detail.unitId && registration.registrationUrl != null}
                      <div class="col-md-6">
                        <span class="title color-blue d-block mb-1 font-weight-500"
                          >Registration URL</span
                        >
                        <span class="font-size-12 font-weight-400 d-block"
                          >{@html registration.registrationUrl != null
                            ? createLinkIfValidUrl(registration.registrationUrl)
                            : ''}</span
                        >
                      </div>
                    {/if}
                  </div>

                  {#if detail.registrationTypes.length != i + 1}
                    <hr />
                  {/if}
                {/each}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Registration Type End -->
{/if}

{#if (detail.sows != undefined && detail.sows.length > 0) || pastProject.length > 0 || activeProject.length > 0}
  <!-- Engagement Type Start -->
  <div class="p-3 content-section pb-0">
    <span class="font-size-14 mb-2 font-weight-500 d-block">Engagement Type</span>
    <div class="row mb-1">
      <div class="col-md-12">
        <div class="row">
          <div class="">
            <div class="d-flex flex-row align-items-center">
              <div class="me-3 color-blue font-weight-500">Project</div>

              <div class="task-project-count px-2 py-1 btn-group btn-submenu settings-btn">
                <button
                  type="button"
                  class="bg-transparent btn-setting-icon border-0 dropdown-toggle dropdown-toggle-view position-relative d-flex align-items-center"
                  data-bs-toggle="dropdown"
                  data-bs-display="static"
                  aria-expanded="false"
                >
                  <strong class="font-size-12 font-weight-500">{pastProject.length}&nbsp;</strong>
                  <span class="font-size-12 font-weight-400">Past</span>&nbsp;&nbsp;
                  <strong class="font-size-12 font-weight-500">{activeProject.length}&nbsp;</strong>
                  <span class="font-size-12 font-weight-400">Active</span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-lg-start top-header-menu client-details-menu"
                >
                  {#if pastProject.length > 0}
                    <div class="activity-submenu">
                      <div class="font-weight-500">Past Projects</div>
                      <div class="project-short-scroll">
                        {#each pastProject as past, i}
                          <div
                            class="d-flex flex-row justify-content-between font-size-11 task-list-block"
                          >
                            <div>
                              <span class="font-size-12 font-weight-400 text-break"
                                >{past.name} | From:
                                {past.startDateFormat}
                                {past.endDateFormat == '' || past.endDateFormat == '0000-00-00'
                                  ? ''
                                  : 'To: ' + past.endDateFormat}</span
                              >
                            </div>
                          </div>
                        {/each}
                      </div>
                    </div>
                  {/if}
                  {#if activeProject.length > 0}
                    <div class="activity-submenu">
                      <div class="font-weight-500">Active Projects</div>
                      <div class="project-short-scroll">
                        {#each activeProject as active, i}
                          <div
                            class="d-flex flex-row justify-content-between font-size-11 task-list-block"
                          >
                            <div>
                              <span class="font-size-12 font-weight-400 text-break"
                                >{active.name} | From: {active.startDateFormat}
                                {active.endDateFormat == '' || active.endDateFormat == '0000-00-00'
                                  ? ''
                                  : 'To: ' + active.endDateFormat}</span
                              >
                            </div>
                          </div>
                        {/each}
                      </div>
                    </div>
                  {/if}
                </div>
              </div>
              {#if isActivityLog == false && (pastProject.length > 0 || activeProject.length > 0)}
                <button
                  class="bg-transparent border-0 btn-link color-blue ms-1"
                  type="button"
                  on:click={() => {
                    clientModal.hide();
                    navigate(
                      '/redirect/assigntask#action=View&clientId=' +
                        detail.id +
                        '&unitId=' +
                        detail.unitId +
                        '&type=project',
                    );
                  }}
                >
                  <img
                    class="icon-16 me-1"
                    alt=""
                    src="/images/assign-task.svg"
                  />
                  Assign Tasks
                </button>
              {/if}
            </div>
          </div>
          <div class="mt-1">
            <div class="d-flex flex-row align-items-center">
              <div class="me-3 font-weight-500 text-nowrap">
                <span class="color-blue">Ongoing</span>
                {#if detail.ongoing == 1}
                  &nbsp;From: {detail.ongoingStartDateFormat}&nbsp;&nbsp;{detail.ongoingEndDateFormat
                    ? 'To: '
                    : ''}{detail.ongoingEndDateFormat}{/if}
              </div>
              <div class="task-project-count px-2 py-1 btn-group btn-submenu settings-btn">
                <button
                  type="button"
                  class="bg-transparent btn-setting-icon border-0 dropdown-toggle dropdown-toggle-view position-relative d-flex align-items-center"
                  data-bs-toggle="dropdown"
                  data-bs-display="static"
                  aria-expanded="false"
                >
                  <strong>{detail.sows == undefined ? 0 : detail.sows.length}</strong>&nbsp;
                  <span class="font-size-12 font-weight-400">Engagement Services Items</span>
                </button>
                {#if detail.sows != undefined}
                  <div
                    class="dropdown-menu dropdown-menu-lg-start top-header-menu client-details-menu"
                  >
                    <div class="activity-submenu">
                      <div class="font-weight-500">Ongoing</div>
                      <div class="project-short-scroll">
                        {#each detail.sows as ongoing, i}
                          <div class=" task-list-block">
                            {ongoing.unitSowId > 0 ? ongoing.name : ongoing.otherName}
                          </div>
                        {/each}
                      </div>
                    </div>
                  </div>
                {/if}
              </div>
              {#if isActivityLog == false && detail.sows != undefined}
                <button
                  class="bg-transparent border-0 btn-link color-blue ms-1"
                  type="button"
                  on:click={() => {
                    clientModal.hide();
                    navigate(
                      '/redirect/assigntask#action=View&clientId=' +
                        detail.id +
                        '&unitId=' +
                        detail.unitId +
                        '&type=ongoing',
                    );
                  }}
                >
                  <img
                    class="icon-16 me-1"
                    alt=""
                    src="/images/assign-task.svg"
                  />
                  Assign tasks from the library
                </button>
              {/if}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Engagement Type End -->
{/if}

{#if detail.users != undefined && detail.users.length > 0}
  <!-- Users  Start -->
  <div class="p-3 content-section pb-0">
    <div class="d-flex mb-2 justify-content-between align-items-center">
      <span class="font-size-14 mb-2 font-weight-500 d-block">Staff Assignments</span>
      <button
        type="button"
        class="task-filter-icon btn btn-primary border-0 px-2 rounded ms-2 text-nowrap font-size-13"
        on:click={() => viewGroup(detail)}
      >
        User Groups
      </button>
    </div>
    <div class="d-flex flex-row flex-wrap">
      {#each detail.users as iuser, i}
        <div class="d-flex flex-row align-items-center mb-2 d-inline-block me-3">
          <ProfileImg
            size={40}
            photoUrl={isActivityLog ? '' : iuser.photoUrlPath}
            firstName={iuser.firstName}
            lastName={iuser.lastName}
            className="d-inline-block align-middle me-2"
          />

          <span class="font-size-12 font-weight-400 d-block text-break"
            >{iuser.firstName + ' ' + iuser.lastName}
            {iuser.userCategoryName != '' ? '(' + iuser.userCategoryName + ')' : ''}</span
          >
        </div>
      {/each}
    </div>
  </div>
  <!-- Users End -->
{/if}

{#if detail.fundProfiles != undefined && detail.fundProfiles.length > 0}
  <!-- Fund Profiles Start -->
  <div
    class="p-3 content-section funds-section pb-0"
    id="fundDivRef"
  >
    <span class="font-size-14 mb-2 font-weight-500 d-block"
      >Funds
      <span class="badge bg-primary ms-2"
        >{detail.fundProfiles == undefined ? 0 : detail.fundProfiles.length}</span
      ></span
    >

    {#each detail.fundProfiles as item, key}
      <div class="d-flex accordion-flush-items">
        <div
          class="accordion w-100"
          id="accordionFunds{key}"
        >
          <FundsItems
            fundsItem={item}
            key={key}
            selectUnitsInfo={selectUnitsInfo}
            active={clientFundProfileId != undefined && clientFundProfileId == item.id}
          />
        </div>
      </div>
    {/each}
  </div>
  <!-- Fund Profiles Type End -->
{/if}

{#if (detail.attachments != undefined && detail.attachments.length > 0) || (detail.urls != undefined && detail.urls.length > 0)}
  <!-- Attachment Start -->
  <div class="p-3 content-section pb-0">
    <span class="font-size-14 mb-2 font-weight-500 d-block"
      >Link to or Attachment of The Service</span
    >
    <div class="d-flex flex-row flex-wrap">
      {#if detail.attachments}
        <div class="filepreview-client-detail filepreview-list-scroller">
          <ul
            class="filepreview-list"
            role="list"
          >
            {#each detail.attachments as attachments, i}
              <li class="filepreview-item">
                {#if isActivityLog}
                  <span class="font-weight-400 font-size-12"
                    >{attachments.origionalName
                      ? attachments.origionalName
                      : attachments.fileName}</span
                  >
                {:else}
                  <button
                    class="btn btn-link p-0 m-0 shadow-none bg-transparent border-0"
                    on:click={() => {
                      fileDownload(
                        attachments.fileId,
                        attachments.origionalName
                          ? attachments.origionalName
                          : attachments.fileName,
                      );
                    }}
                  >
                    <span class="font-weight-400 font-size-12 color-black"
                      >{attachments.origionalName
                        ? attachments.origionalName
                        : attachments.fileName}
                    </span>
                  </button>
                {/if}
              </li>
            {/each}
          </ul>
        </div>
        <!-- <a class="btn-link" href={attachments.downloadUrl}>
		<FilePreview Style="me-1 mb-1" />
	  </a> -->
      {/if}
    </div>
    <div class="d-flex flex-row flex-wrap">
      <ul class="filte-upload font-size-13 mb-0 p-0 mt-1">
        {#if detail.urls}
          {#each detail.urls as item, key}
            <li class="d-flex flex-row align-items-center mb-1">
              <img
                class="icon-16 me-1"
                alt=""
                src="/images/globe.svg"
              />
              <span class="text-break font-size-12 font-weight-400"
                ><a
                  href={item.url}
                  target="_blank"
                  >{item.title != null && item.title.trim() != '' ? item.title : item.url}</a
                ></span
              >
            </li>
          {/each}
        {/if}
      </ul>
    </div>
  </div>
  <!-- Attachment End -->
{/if}

{#if detail.billingAddress != '' || detail.street != '' || detail.city != '' || detail.state != '' || detail.zip != '' || detail.country != '' || (detail.contacts != undefined && detail.contacts.length > 0)}
  <!-- Address -->
  <div class="p-3 content-section">
    <!-- {#if detail.billingAddress !=""|| (detail.street !='' || detail.city !='' || detail.state !='' ||detail.zip !=''  || detail.country !='')}
{/if} -->

    <span class="font-size-14 mb-2 font-weight-500 d-block mt-0">Address</span>
    {#if detail.addresses != undefined && detail.addresses.length > 0}
      {#each detail.addresses as address, key}
        <div class="box-block rounded p-2 mb-1">
          <div class="row">
            <div class="col-md-12">
              <label
                for=""
                class="mb-1 font-weight-500 d-block">Address {key + 1}</label
              >
              <span class="text-break font-size-12 font-weight-400">
                {address.street}
                {address.city}
                {address.stateName}{address.stateName != '' && address.zip != ''
                  ? ', ' + address.zip
                  : ''}
                <br />
                {address.countryName}
              </span>
            </div>
            <!-- <div class="col-md-6">
		<span class="title color-blue d-block  mb-1">Billing Address</span>
		<span class="text-break">{detail.billingAddress}
		</span>
	  </div> -->
          </div>
        </div>
      {/each}
    {/if}
    {#if detail.contacts != undefined && detail.contacts.length > 0}
      <div>
        <span class="font-size-14 mb-2 mt-3 font-weight-500 d-block">Client Contacts</span>
        <div class="row">
          <div class="col">
            <span class="font-size-12 color-blue font-weight-500 d-block">Contact Name(s)</span>
          </div>
          <div class="col">
            <span class="font-size-12 color-blue font-weight-500 d-block">Title</span>
          </div>
          <div class="col">
            <span class="font-size-12 color-blue font-weight-500 d-block">Phone No</span>
          </div>
          <div class="col">
            <span class="font-size-12 color-blue font-weight-500 d-block">Email</span>
          </div>
        </div>
        {#each detail.contacts as contact, i}
          <div class="row">
            <div class="col">
              <span class="font-size-12 font-weight-400 d-block text-break">{contact.name}</span>
            </div>
            <div class="col">
              <span class="font-size-12 font-weight-400 d-block text-break">{contact.title}</span>
            </div>
            <div class="col">
              <span class="font-size-12 font-weight-400 d-block text-break">{contact.phone}</span>
            </div>
            <div class="col">
              <span class="font-size-12 font-weight-400 d-block text-break">{contact.email}</span>
            </div>
          </div>
        {/each}
      </div>
    {/if}
  </div>
  <hr class="mb-0 mt-0" />
  <!-- Address -->
{/if}

{#if unitIds.outsourced_cfo != detail.unitId && detail.serviceProviders != undefined && detail.serviceProviders.length > 0}
  <div class="p-3 content-section">
    <div>
      <span class="font-size-14 mb-2 mt-0 font-weight-500 d-block">Service Provider Contacts</span>

      {#each detail.serviceProviders as serviceProvider, i}
        <div class="mb-0 w-100 service-provider-block">
          <div class="row">
            <div class="col">
              <span class="font-size-12 color-blue font-weight-500 d-block"
                >Service Provider Name</span
              >
            </div>
            <div class="col">
              <span class="font-size-12 color-blue font-weight-500 d-block">Type</span>
            </div>
            <div class="col">
              <span class="font-size-12 color-blue font-weight-500 d-block">Phone No</span>
            </div>
            <div class="col">
              <span class="font-size-12 color-blue font-weight-500 d-block">Email</span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span class="font-size-12 font-weight-400 d-block text-break"
                >{serviceProvider.name}</span
              >
            </div>
            <div class="col">
              {#if serviceProvider.serviceProviderTypeId == '' || serviceProvider.serviceProviderTypeId == null}
                <span class="font-size-12 font-weight-400 d-block text-break"
                  >{configItem.service_provider_other_prefix + ' ' + serviceProvider.type}</span
                >
              {:else}
                <span class="font-size-12 font-weight-400 d-block text-break"
                  >{serviceProvider.serviceProviderTypeName}</span
                >
              {/if}
            </div>
            <div class="col">
              <span class="font-size-12 font-weight-400 d-block text-break"
                >{serviceProvider.phone}</span
              >
            </div>
            <div class="col">
              <span class="font-size-12 font-weight-400 d-block text-break"
                >{serviceProvider.email}</span
              >
            </div>
          </div>
          {#if serviceProvider.notes != ''}
            <div class="row mt-2">
              <div class="col">
                <span class="font-size-12 color-blue font-weight-500 d-block">Notes</span>
                <span class="font-size-12 font-weight-400 d-block">{serviceProvider.notes}</span>
              </div>
            </div>
          {/if}
        </div>
      {/each}
    </div>
  </div>
  <hr class="mt-0 mb-0" />
{/if}

{#if detail.ethicsOtherName != '' || detail.unitCodeEthicsName != '' || detail.notes != '' || detail.assetsManagement != '' || detail.employeesNo != '' || detail.legacyCompanyTypeName != ''}
  <!-- Other Information Start -->
  <div class="p-3 content-section pb-0 mb-3">
    <span class="font-size-14 mb-2 font-weight-500 d-block">Other Information</span>
    <div class="box-block rounded p-2">
      <div class="row">
        {#if unitIds.outsourced_cfo !== detail.unitId}
          <div class="col-md-12">
            <span class="title color-blue d-block mb-1 mt-2 font-weight-500"
              >Code of Ethics Software</span
            >
            <p class="mt-0 font-size-12 font-weight-400 d-block text-break mb-0">
              {detail.unitCodeEthicsName == 'Other'
                ? detail.ethicsOtherName
                : detail.unitCodeEthicsName}
            </p>
          </div>
        {/if}

        <div class="col-md-12">
          <span class="title color-blue d-block mb-1 mt-2 font-weight-500">Other Key Details</span>
          <p class="mt-0 font-size-12 font-weight-400 d-block text-break mb-0">
            {detail.notes}
          </p>
        </div>
        <div class="col-md-12">
          <span class="title color-blue d-block mb-1 mt-2 font-weight-500"
            >Assets Under Management</span
          >
          <p class="mt-0 font-size-12 font-weight-400 d-block text-break mb-0">
            {detail.assetsManagement}
          </p>
        </div>
        <div class="col-md-12">
          <span class="title color-blue d-block mb-1 mt-2 font-weight-500">Number of Employees</span
          >
          <p class="mt-0 font-size-12 font-weight-400 d-block text-break mb-0">
            {detail.employeesNo}
          </p>
        </div>
        <div class="col-md-12">
          <span class="title color-blue d-block mb-1 mt-2 font-weight-500">Legacy Company</span>
          <p class="mt-0 font-size-12 font-weight-400 d-block text-break mb-0">
            {detail.legacyCompanyTypeName}
          </p>
        </div>
      </div>
    </div>
  </div>
  <!-- Other Information End -->
{/if}

<style lang="scss">
  .filepreview-client-detail {
    ul {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .filepreview-item {
        span {
          font-size: 12px;
          line-height: 1.2;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          max-width: 802px;
          display: inline-block;
          margin-right: 77px;
          overflow: hidden;
        }
      }
    }
  }
  .content-section {
    .task-project-count {
      background: rgba($input-border-color, 0.3);
    }
  }

  .dropdown-menu {
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.25);
    border: 0;
    min-width: 10rem;
    font-size: 14px;
    border-radius: 4px;
    margin-top: 15px;
    &:before {
      display: inline-block;
      content: '';
      position: absolute;
      top: -8px;
      right: 12px;
      border-right: 10px solid transparent;
      border-bottom: 10px solid #fff;
      border-left: 10px solid transparent;
    }
  }
  .activity-submenu {
    padding: 3px 6px;
    font-size: 13px;
  }
  .client-details-menu {
    min-width: 350px;
    &::before {
      left: 9px !important;
      right: auto !important;
    }
  }
  .task-list-block {
    border-bottom: 1px solid $input-border-color;
    padding: 4px 0;
    font-size: 11px;
  }
  .project-short-scroll {
    max-height: 150px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 6px;
    margin-right: -6px;
    .task-list-block {
      &:last-child {
        border: 0px !important;
        padding-bottom: 0px !important;
      }
    }
  }
  .client-type-main {
    .client-type-inner:last-child hr {
      display: none;
    }
  }
</style>
